export default __webpack_public_path__ + "static/media/SZ.b939e891.svg";